import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        fromHour: null,
        fromMinute: null,
        toHour: null,
        toMinute: null,
        title: null
    },
    getters: {
        getFromHour: (state) => {
            return state.fromHour;
        },
        getFromMinute: (state) => {
            return state.fromMinute;
        },
        getToHour: (state) => {
            return state.toHour;
        },
        getToMinute: (state) => {
            return state.toMinute;
        },
        getTitle: (state) => {
            return state.title;
        }
    },
    mutations: {
        setFromHour: (state, fromHour) => {
            state.fromHour = fromHour;
        },
        setFromMinute: (state, fromMinute) => {
            state.fromMinute = fromMinute;
        },
        setToHour: (state, toHour) => {
            state.toHour = toHour;
        },
        setToMinute: (state, toMinute) => {
            state.toMinute = toMinute;
        },
        setTitle: (state, title) => {
            state.title = title;
        }
    }
});